import React from "react";
import { Fragment } from "react"
import { PhotoProvider, PhotoView } from 'react-photo-view';

type PhotosProps = {
    photos: any,
    loadPhotos: () => any,
    apiUrl: () => any,
}
export const Photos = ({ photos, loadPhotos, apiUrl }: PhotosProps) => {
    return (
        <Fragment>
            <PhotoProvider>
            {!photos && 
                <button onClick={loadPhotos} className="btn btn-warning btn-lg">
                    Cargar imagenes
                    <div className="ripple-container"></div>
                </button>
            }
            {photos && photos.length === 0 &&
                <h2>No hay imagenes</h2>
            }
            {photos && photos.map((photo: any, index: any) => {
                    return (
                        <Fragment key={index}>
                            <div className="card">
                                <div
                                    className="card-body"
                                    style={{ textAlign: "center" }}
                                >
                                    <PhotoView key={index} src={photo}>
                                        <img
                                            src={photo}
                                            alt="Imagen"
                                            style={{ maxWidth: 300 }}
                                        />
                                    </PhotoView>
                                </div>
                            </div>
                        </Fragment>
                    );
                })}
            </PhotoProvider>
        </Fragment>);
}